export const VEHICLE_MILEAGE_PER_YEAR = 12000;

export const SEO_IMAGES_PAGE_SIZE = 15;
export const SEO_IMAGES_WIDTHS = '1600,500,175';

export const SEO_IMAGE_SIZE = { width: 1280, height: 855 };

export const CORE_GALLERY_SIZE = {
  DESKTOP: { HERO: { width: 815, height: 543 }, ROW: { width: 175, height: 117 } },
  MOBILE: { HERO: { width: 600, height: 400 }, ROW: { width: 500, height: 333 } },
};
